import { ModalController } from '@ionic/angular';
import { Component, Input, OnInit, Output, EventEmitter, ViewChild, ElementRef, OnDestroy, OnChanges } from '@angular/core';
// import { ViewDocumentModalComponent } from '@modals/view-document/view-document.component';
import { AbstractControl, FormControl } from '@angular/forms';
import { PreviewFileModalComponent } from '@modals/preview-file/preview-file.component';

@Component({
    selector: 'input-browse',
    templateUrl: './input-browse.component.html',
    styleUrls: ['./input-browse.component.scss'],
})
export class InputBrowseComponent implements OnInit, OnChanges, OnDestroy {

    @Input() buttonName: string = "Escolher ficheiro";

    @Input('control') FormControl: AbstractControl;
    @Input() accept: string = "image/jpg, image/jpeg, image/png";
    @Input('fileURL') FileURL: string;
    @Input('fileName') Filename: string;
    @Input('disabled') Disabled: boolean;
    @Input('template') TemplateFile: string;
    @Input('delete') onDelete: Function;

    @Output('callback') callback: EventEmitter<any> = new EventEmitter<any>();

    @ViewChild('file') File: ElementRef;

    constructor(private ModalController: ModalController) { }

    ngOnInit() {

        // console.log(this.FormControl, this.FileURL, this.Filename, this.TemplateFile);

    }

    ngOnChanges() {

        // console.log(this.FormControl, this.FileURL, this.Filename, this.TemplateFile);

    }
    async ngOnDestroy() {

        const current = await this.ModalController.getTop();

        if (current) current.dismiss();

    }


    OnFileChange(ev?: any) {

        if (!ev || this.Disabled || (this.FormControl && this.FormControl?.disabled)) return;

        const input = ev?.target as HTMLInputElement;

        console.log(input);


        if (!input.files || input.files.length === 0) {
            return;
        }

        if (this.FormControl) {

            if (this.callback) {
                this.callback.emit(input);
            }

            this.FormControl.markAsTouched();
        }
        else {

            this.FileURL = null;

            // this.Filename = this.File.nativeElement?.files[0].name || null;

            if (this.callback) this.callback.emit(input);
        }


    }

    async OnViewFile(ev: any) {

        const modal = await this.ModalController.create({
            component: PreviewFileModalComponent,
            componentProps: {
                url: this.FileURL
            },
            cssClass: 'default full max',

        });

        modal.present();

        // window.open(this.FileURL, '_blank');
    }

    async OnDelete(ev?: any) {

        ev?.preventDefault();
        ev?.stopPropagation();

        if (!this.onDelete) return;

        this.onDelete(this.File);

    }
}
